import { api } from '@/service/http';
import { getCookie } from '@/utils/cookies';

export const getSlovarList = async () => {
    const appId = +getCookie('app');
    try {
        const args = {
            esysId: 1, // TODO: заменить на вытаскивание из базы или еще откуда то
            appId,
        };
        const { result, items } = await api('core./nsi/slovar/list/get', args);
        return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5e51e2a8-678f-461c-8a90-bb34ed8f79c4',
        };
    }
};

export const getNsiTreeviewData = async app => {
    try {
        const { result, data } = await api('meta./meta/nsi-treeview-data/get', { id_app: app,  appId: app});
        return result ? data : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '4d8b964c-03c2-4116-a9a8-e1a0c56ccc56',
        };
    }
};

export const getBookMeta = async code => {
    const appId = +getCookie('app');
    try {
        const { result, items } = await api('core./nsi/slovar/meta/get', { appId, code });
        return result ? items[0] : {};
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '82832ba9-9546-4f9e-868f-bfd6b599f933',
        };
    }
};

export const getBookData = async code => {
    const appId = +getCookie('app');
    try {
        return await api('core./nsi/book/data/get', { appId, code });
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '1c1a3243-be69-4b05-a39d-bd2408982d59',
        };
    }
};

export const getCardData = async (id, type) => {
    const appId = +getCookie('app');
    const urlType = type === 'd' ? 'department/official' : 'official/employee';
    try {
        return await api(`admin./${urlType}/card/get`, { appId, id });
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '9ee04813-474b-4f7c-a510-3f0b4d91ff83',
        };
    }
};


export const getNsiOrgstructureTreeviewData = async () => {
    try {
        const { result, data } = await api('meta./meta/ai-grid-ro/select/get', {meta_args: {select: 'payer.hf_get_dictionary'}, select_args: {schema: 'admin', table: 'kv_nsi_orgstructure', where: 'pr_active=0'}});
        return result ? data.data : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '4d8b964c-03c2-4116-a9a8-e1a0c56ccc56',
        };
    }
};

export const getValueFromChooser = async (kod_emp, kod_dep) => {
    try {
        const response = await api('counteragent./dog/kr-dogobj-emp-user-select/get', {kod_emp: kod_emp, kod_dep: kod_dep});
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'dbafdd07-4493-4afb-847e-c76a180feea0'
        };
    }
}

export const getNsiOrgCardData = async (id, parent_id) => {
    try {
        const { result, data } = await api('admin./department/card/get',  {id: id, parent_id: parent_id});
        return {result: result, data: data};
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5ffd9771-cefc-4f39-bdec-0515b7fb9a05',
        };
    }
};

export const getNsiEmpCardData = async (id, parent_id) => {
    try {
        const { result, data } = await api('admin./employee/card/get',  {id: id, parent_id: parent_id});
        return {result: result, data: data};
        //return result ? items : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '85bb6841-3ff1-4468-b74f-4a42eb9e465a',
        };
    }
};

export const saveNsiOrgCard = async args => {
    try {
        const response = await api('admin./department/card/save', args);
        return response
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'f0f35bcd-b04f-46f1-bafd-93124b0a99c3',
        };
    }
};

export const deleteNsiOrgData = async (id) => {
    try {
        const result = await api('admin./department/delete',  {id: id});
        return result;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '',
        };
    }
};

export const deleteNsiEmpData = async (id) => {
    try {
        const result = await api('admin./employee/delete',  {id: id});
        return result;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '',
        };
    }
};

export const saveNsiEmpCard = async args => {
    try {
        const response = await api('admin./employee/card/save', args);
        return response
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '5d109f16-4e0d-45ed-a25e-0900e99f3717',
        };
    }
};

export const moveOrgEmp = async args => {
    try {
        const response = await api('admin./department/move', args);
        return response;
    } catch (error) {
        return {
            result: false,
            errors: [{message: error.message}],
            uuid: '0841ae18-d1c2-4b66-9337-305b4f4cd561',
        };
    }
};
